import { render, staticRenderFns } from "./DealerWorksList.vue?vue&type=template&id=1cd842b3&scoped=true"
import script from "./DealerWorksList.vue?vue&type=script&lang=js"
export * from "./DealerWorksList.vue?vue&type=script&lang=js"
import style0 from "./DealerWorksList.vue?vue&type=style&index=0&id=1cd842b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd842b3",
  null
  
)

export default component.exports